<template>
  <div class="base">
    <common-layout>
      <div slot="header">
        <h3>科研仪器</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623AA2; border: none;"
          >新增</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width:240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <label style="line-height:40px">服务领域:</label>
          <el-select
            style="width:140px"
            v-model="fieldValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="仪器设备名称" align="center" prop="name"></el-table-column>
            <el-table-column label="规格型号" align="center" prop="model"></el-table-column>
            <el-table-column label="制造厂商" align="center" prop="factory"></el-table-column>
            <el-table-column label="国别" align="center" prop="level"></el-table-column>
            <el-table-column label="日期" align="center" prop="dateTime"></el-table-column>
            <el-table-column label="是否推荐" align="center" prop="hot">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hot == 1" type="success" effect="plain">是</el-tag>
                <el-tag v-else type="danger" effect="plain">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="180px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      @closed="is_submit = true"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm"  ref="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="仪器设备名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入仪器设备名称"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="规格型号" prop="model">
                <el-input v-model="ruleForm.model" placeholder="请输入规格型号"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="制造厂商" prop="factory">
                <el-input v-model="ruleForm.factory" placeholder="请输入制造厂商"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="国别" prop="level">
                <el-input v-model="ruleForm.level" placeholder="请输入国别"></el-input>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img v-if="ruleForm.logo" :src="imgUrl+ruleForm.logo" class="img_border" v-real-img="ruleForm.logo" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{is_border: !ruleForm.logo}"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.logo">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="原值金额(万元)" prop="money">
              <el-input v-model="ruleForm.money" placeholder="请输入原值金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购置日期" prop="buyTime">
              <el-date-picker
                :picker-options="pickerOptions"

                style="width:100%"
                v-model="ruleForm.buyTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="服务领域" prop="field">
            <el-checkbox-group style="text-align:left;" v-model="ruleForm.field">
              <el-checkbox
                v-for="item in fieldOptions"
                :label="item.value"
                :key="item.value"
                @change="handleChecked"
              >{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <el-input v-model="ruleForm.fieldQita" placeholder="请输入其他服务领域" :disabled="disabled"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务机构" prop="industry">
              <el-input v-model="ruleForm.industry" placeholder="请输入服务机构"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="telephone">
              <el-input v-model="ruleForm.telephone" placeholder="请输入电话号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="设备原值(万元)" prop="equipmentOriginValue">
              <el-input v-model="ruleForm.equipmentOriginValue" placeholder="请输入设备原值"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务企业及团队数(家)" prop="servicedCount" class="special">
              <el-input v-model="ruleForm.servicedCount" placeholder="请输入服务企业及团队数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务成果(个)" prop="serviceAchievementsCount">
              <el-input v-model="ruleForm.serviceAchievementsCount" placeholder="请输入服务成果"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电子邮件" prop="mail">
              <el-input v-model="ruleForm.mail" placeholder="请输入电子邮件"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通讯地址" prop="detailed">
            <v-distpicker
              style="text-align:left;"
              @selected="citySelected"
              :province="ruleForm.address.province.value"
              :city="ruleForm.address.city.value"
              :area="ruleForm.address.area.value"
            ></v-distpicker>
            <el-input style="margin-top:10px" v-model="ruleForm.detailed" placeholder="请填写详细地址"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="实景图" style="text-align:center">
            <el-upload
              style="text-align:left"
              :action="this.uploadURL"
              list-type="picture-card"
              :file-list="fileList"
              :on-preview="pictureCardPreview1"
              :before-upload="beforeUpload1"
              :on-remove="handleRemove1"
              :http-request="HouImgFile1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="主要技术指标" prop="technology">
            <!-- <editor refName='technology' :placeholder="'请填写主要技术指标'" :quill-data="ruleForm.technology" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
            <editor
              refName="technology"
              :placeholderText="'请填写主要技术指标'"
              v-model="ruleForm.technology"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="主要应用功能" prop="capacity">
            <!-- <editor refName='capacity' :placeholder="'请填写主要应用功能'" :quill-data="ruleForm.capacity" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData1"></editor> -->
            <editor
              refName="capacity"
              :placeholderText="'请填写主要应用功能'"
              v-model="ruleForm.capacity"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="技术服务内容" prop="content">
            <!-- <editor refName='content' :placeholder="'请填写技术服务内容'" :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData2"></editor> -->
            <editor
              refName="content"
              :placeholderText="'请填写技术服务内容'"
              v-model="ruleForm.content"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item style="text-align:left" label="是否推荐" prop="hot">
              <el-switch
                v-model="ruleForm.hot"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推荐度" prop="hotOrder">
              <!-- <el-input v-model.number="ruleForm.hotOrder" placeholder="请输入推荐度" :disabled="ruleForm.hot == 2"></el-input> -->
              <el-slider v-model="ruleForm.hotOrder" show-input :disabled="ruleForm.hot == 2"></el-slider>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item style="text-align:left" label="共享" prop="isShare">
              <el-switch
                v-model="ruleForm.isShare"
                :active-value="2"
                :inactive-value="1"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
import { DisabledDateFn } from "../../utils/tool";

export default {
  components: {
    CommonLayout,
    editor,
  },
  data() {
    var validateHoto = (rule, value, callback) => {
      if (this.ruleForm.hot == 1) {
        if (!value) {
          callback(new Error("请设置推荐度"));
        }
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
          pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      is_submit : true,
      fieldValue: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      disabled: true,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      deleteRow: "",
      fileList: [],
      tableData: [],
      fieldOptions: [
        {
          value: "001",
          label: "电子通讯",
        },
        {
          value: "002",
          label: "生物医药",
        },
        {
          value: "003",
          label: "轻工食品",
        },
        {
          value: "004",
          label: "农业",
        },
        {
          value: "005",
          label: "化工",
        },
        {
          value: "006",
          label: "新材料",
        },
        {
          value: "007",
          label: "环保",
        },
        {
          value: "008",
          label: "机械",
        },
        {
          value: "009",
          label: "冶金",
        },
        {
          value: "010",
          label: "计算机及网络",
        },
        {
          value: "011",
          label: "能源",
        },
        {
          value: "012",
          label: "其他",
        },
      ],
      ruleForm: {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        model: "",
        factory: "",
        level: "",
        money: "",
        buyTime: "",
        fieldQita: "",
        industry: "",
        telephone: "",
        mail: "",
        phone: "",
        field: [],
        technology: "",
        capacity: "",
        content: "",
        hot: 2,
        isShare: 1,
        hotOrder: 0,
        equipmentOriginValue: "",
        servicedCount: "",
        serviceAchievementsCount: "",
      },
      rules: {
        detailed: [
          {
            validator: (rule, value, callback) =>
              this.CheckAddress(rule, value, callback, this.ruleForm),
            required: true,
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入仪器设备名称", trigger: "blur" },
        ],
        model: [{ required: true, message: "请输入规格型号", trigger: "blur" }],
        factory: [
          { required: true, message: "请输入制造厂商", trigger: "blur" },
        ],
        level: [{ required: true, message: "请输入国别", trigger: "blur" }],
        money: [
          { required: true, message: "请输入原值金额", trigger: "chang" },
        ],
        buyTime: [
          { required: true, message: "请选择购置日期", trigger: "blur" },
        ],
        logo: [{ required: true, message: "请上传logo", trigger: "blur" }],
        field: [
          {
            type: "array",
            required: true,
            message: "请选择服务领域",
            trigger: "change",
          },
        ],
        industry: [
          { required: true, message: "请输入服务机构", trigger: "chang" },
        ],
        telephone: [
          { required: true, message: "请输入电话号码", trigger: "chang" },
        ],
        mail: [{ required: true, message: "请输入电子邮件", trigger: "chang" }],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "chang" },
        ],
        technology: [
          { required: true, message: "请输入主要技术指标", trigger: "blur" },
        ],
        capacity: [
          { required: true, message: "请输入主要应用功能", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入技术服务内容", trigger: "blur" },
        ],
        hotOrder: [
          { required: true, validator: validateHoto, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getData("Resource_Instrument?all=1&page=" + this.current_page);
  },
  methods: {
        //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-instrument/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data?.total || 0;
          this.per_page = res.data?.per_page || 10;
          this.current_page = (res.data?.current_page|| 1) * 1;
        }
      });
    },
    handleChecked() {
      if (this.ruleForm.field?.length) {
        let isTrue = true;
        this.ruleForm?.field.forEach((item) => {
          if (item == "012") {
            isTrue = false;
          }
        });
        this.disabled = isTrue;
      } else {
        this.disabled = true;
      }
    },
    //城市选择
    citySelected(e) {
      this.ruleForm.address = e;
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.technology = val;
    },
    getQuillData1(val) {
      this.ruleForm.capacity = val;
    },
    getQuillData2(val) {
      this.ruleForm.content = val;
    },
    //新增
    addEvent() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.fileList = [];
      this.ruleForm = {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        model: "",
        factory: "",
        level: "",
        money: "",
        buyTime: "",
        fieldQita: "",
        industry: "",
        telephone: "",
        mail: "",
        phone: "",
        field: [],
        technology: "",
        capacity: "",
        content: "",
        hot: 2,
        isShare: 1,
        hotOrder: 0,
        equipmentOriginValue: "",
        servicedCount: "",
        serviceAchievementsCount: "",
      };
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-instrument/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.getData(
                    "Resource_Instrument?all=1&page=1"
                  );
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
            this.ResetSearch(['fieldValue','searchValue'])

                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //搜索
    search() {
      this.current_page = 1
      this.getData(
        "Resource_Instrument?all=1&name=" +
          this.searchValue +
          "&page=" +
          this.current_page +
          (this.fieldValue ? "&field=" + this.fieldValue : "")
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection?.length) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      row.detailed = row.address ? row.address.detailed : "";
      row.address = row.address
        ? row.address
        : { province: { value: "" }, city: { value: "" }, area: { value: "" } };
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      this.ruleForm.field = row.field?.split(",") || [];
      // this.ruleForm.detailed = row.address.detailed
      if (row.image) {
        let arr = [];
        arr = row.image?.split(",") || [];
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
      this.handleChecked();
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-instrument/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.getData(
                  "Resource_Instrument?all=1&page=" + this.current_page
                );
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
            this.ResetSearch(['fieldValue','searchValue'])

              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
        "Resource_Instrument?all=1&name=" +
          this.searchValue +
          "&page=" +
          e +
          (this.fieldValue ? "&field=" + this.fieldValue : "")
      );
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //获取经纬度
    factory(name) {
      this.$jsonp(
        "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.ruleForm.detailed +
          "&city=" +
          this.ruleForm.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
        .then((json) => {
          let arr = json?.pois[0]?.location?.split(",") || [];
          this.ruleForm.longitude = arr[0];
          this.ruleForm.latitude = arr[1];
          this.subData(name);
        })
        .catch((err) => {
          this.$message.error("未获取到经纬度,请查看地址是否完整");
        });
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.ruleForm));
      let arr = [];
      this.fileList.forEach((item) => {
        if (item.response) {
          arr.push(item.response.data.store_result);
        } else {
          arr.push(item.store_result);
        }
      });
      obj.image = arr.join(",");
      obj.address.detailed = this.ruleForm.detailed;
      obj.field = this.ruleForm.field.join(",");
      obj.dateTime = new Date().format("yyyy-MM-dd hh:mm:ss");
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      area.forEach((item) => {
        if (obj.address.city.value == item.name) {
          obj.area = item.id;
        }
      });
      if (this.disabled) {
        obj.fieldQita = "";
      }
      if (obj.hot == 2) {
        obj.hotOrder = 0;
      }
      delete obj.detailed;
      if(!this.is_submit) {
        return false
      }
      this.is_submit = false
      if (!this.ruleForm.id) {
        this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-instrument/create`, obj).then((res) => {
          if (res.code == 0) {
            this.getData("Resource_Instrument?all=1&page=1");
            this.$message({
              type: "success",
              message: "新增成功",
            });
            this.dialogFormVisible = false;
            this.$refs[name].resetFields();
            let obj1 = {
              name: obj.name,
              moudle: "科研仪器",
              date_time: obj.dateTime,
            };
            this.ResetSearch(['fieldValue','searchValue'])
            // this.http.post("Index_Resource", obj1);
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/index-resource/create`, obj1);
          } else {
            this.is_submit = true
          }
        }).catch(()=>{
          this.is_submit = true
        });
      }
      if (this.Title == "编辑") {
        // delete obj.id;
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-instrument/update`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData("Resource_Instrument?all=1&page=1");
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
            this.ResetSearch(['fieldValue','searchValue'])

            } else {
            this.is_submit = true

            }
          }).catch(err => {
            this.is_submit = true;
          });
      }
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.factory(name);
        } else {
          this.is_submit = true
          return false;
        }
      });
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.ruleForm.logo = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    handlePictureCardPreview(file) {
      this.ruleForm.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.ruleForm.logo = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //上传照片墙
    HouImgFile1(e) {
      var files = e.file;
      if (!files) return;
      this.createImage1(files, e, "HouImg");
    },
    //其他图片上传
    createImage1(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.fileList.push({
                name: file.name,
                url: this.imgUrl + res.data,
                store_result: res.data,
                uid: file.uid,
              });
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    //移除
    handleRemove1(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload1(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview1(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scope>
.base {
  height: 100%;
  width: 100%;
  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
